<script setup lang="ts">
const emits = defineEmits(['updateSection'])

defineProps({
    currentSection: {
        type: String,
        default: 'infos'
    }
})
</script>

<template>
    <div class="w-full bg-white">
        <ul class="inline-flex text-0.5sm w-full overflow-y-auto mr-2">
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'infos'
                }"
                @click="emits('updateSection', 'infos')"
            >
                {{ $t('pool.nav.infos') }}
            </li>
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'stations'
                }"
                @click="emits('updateSection', 'stations')"
            >
                {{ $t('pool.nav.stations') }}
            </li>
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'access'
                }"
                @click="emits('updateSection', 'access')"
            >
                {{ $t('pool.nav.access') }}
            </li>
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'pictures'
                }"
                @click="emits('updateSection', 'pictures')"
            >
                {{ $t('pool.nav.pictures') }}
            </li>
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'reviews'
                }"
                @click="emits('updateSection', 'reviews')"
            >
                {{ $t('pool.nav.reviews') }}
            </li>
            <li
                class="py-2 px-3.5 inline-block whitespace-nowrap cursor-pointer border-b-1 font-medium"
                :class="{
                    'border-b-3 border-[#22BCFF]': currentSection === 'near'
                }"
                @click="emits('updateSection', 'near')"
            >
                {{ $t('pool.nav.near') }}
            </li>
        </ul>
    </div>
</template>
